<!-- Ссылка на рейс: компактная по умолчанию и управляемая карточка в полях связи. -->
<template>
  <BaseRelatedRecordCard
    v-if="relationCard"
    :title="resolvedTitle"
    :subtitle="resolvedSubtitle"
    icon="route"
    :to="tripRoute"
    :view-title="viewTitle"
    :remove-title="removeTitle"
    :removable="removable"
    :disabled="disabled"
    @remove="$emit('remove')"
  />

  <RouterLink
    v-else-if="trip"
    class="trip-entity-link"
    :to="tripRoute"
    @click.stop
  >
    <AppIcon name="route" :size="16" color="#64748b" />
    <span class="trip-entity-link__content">
      <strong>{{ resolvedTitle }}</strong>
      <small>{{ resolvedSubtitle || "Данные рейса не указаны" }}</small>
    </span>
  </RouterLink>

  <span v-else class="trip-entity-link trip-entity-link--empty">
    <span class="trip-entity-link__content">
      <strong>Нет текущего рейса</strong>
    </span>
  </span>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
import { formatDate } from "@/utils/dateUtils";

export default {
  name: "TripEntityLink",

  components: {
    AppIcon,
  },

  props: {
    trip: {
      type: Object,
      default: null,
    },
    relationCard: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    removable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["remove"],

  computed: {
    resolvedTitle() {
      if (this.title) return this.title;
      if (!this.trip) return "Нет выбранного рейса";
      if (this.trip.name) return `Рейс ${this.trip.name}`;

      const date = this.trip.actual_started_at || this.trip.planned_started_at;
      return date ? `Рейс ${formatDate(date)}` : `Рейс #${this.trip.id}`;
    },

    resolvedSubtitle() {
      if (this.subtitle) return this.subtitle;
      if (!this.trip) return "";

      const crew = [
        this.trip.driver_name || this.trip.driverName,
        this.trip.vehicle_registration_number || this.trip.vehicleRegistrationNumber,
      ].filter(Boolean).join(" · ");

      return crew || this.trip.route_cities || this.trip.routeCities || "";
    },

    tripRoute() {
      if (!this.trip?.id) return null;

      return { name: "TripDetails", params: { id: this.trip.id } };
    },

    viewTitle() {
      return this.trip?.id
        ? `Открыть рейс №${this.trip.id} в новой вкладке`
        : "Открыть рейс в новой вкладке";
    },

    removeTitle() {
      return this.trip?.id
        ? `Убрать связь с рейсом №${this.trip.id}`
        : "Убрать связь с рейсом";
    },
  },
};
</script>

<style scoped>
.trip-entity-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  width: 100%;
  height: 44px;
  min-width: 0;
  padding: 3px 6px;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  background: #fff;
  color: inherit;
  text-decoration: none;
  box-sizing: border-box;
}

.trip-entity-link:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.trip-entity-link--empty {
  justify-content: center;
  border-style: dashed;
  background: #f8fafc;
  color: #64748b;
  text-align: center;
}

.trip-entity-link--empty .trip-entity-link__content {
  flex: 0 1 auto;
  text-align: center;
}

.trip-entity-link--empty .trip-entity-link__content strong {
  color: #94a3b8;
  font-weight: 600;
}

.trip-entity-link__content {
  display: grid;
  flex: 1 1 0;
  min-width: 0;
  text-align: left;
}

.trip-entity-link__content strong,
.trip-entity-link__content small {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trip-entity-link__content strong {
  color: #0f172a;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.1;
}

.trip-entity-link__content small {
  color: #64748b;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.1;
}
</style>
